import { render } from "./DonationInformationSection.vue?vue&type=template&id=8389700a&scoped=true"
import script from "./DonationInformationSection.vue?vue&type=script&lang=js"
export * from "./DonationInformationSection.vue?vue&type=script&lang=js"

import "./DonationInformationSection.vue?vue&type=style&index=0&id=8389700a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8389700a"],['__file',"src/components/DonationInformationSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8389700a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8389700a', __exports__)) {
    api.reload('8389700a', __exports__)
  }
  
  module.hot.accept("./DonationInformationSection.vue?vue&type=template&id=8389700a&scoped=true", () => {
    api.rerender('8389700a', render)
  })

}


export default __exports__